"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var MenuRender = {
  name: 'MenuRender',
  functional: true,
  render: function render(h, context) {
    var _context$props = context.props,
        defaultActive = _context$props.defaultActive,
        defaultOpeneds = _context$props.defaultOpeneds,
        uniqueOpened = _context$props.uniqueOpened,
        collapse = _context$props.collapse,
        collapseTransition = _context$props.collapseTransition,
        menus = _context$props.menus,
        redirect = _context$props.redirect;
    return h("el-menu", {
      "attrs": {
        "default-active": defaultActive,
        "default-openeds": defaultOpeneds,
        "unique-opened": uniqueOpened,
        "collapse": collapse,
        "collapse-transition": collapseTransition
      }
    }, [headerRender(h, {
      menus: menus,
      redirect: redirect
    })]);
  }
};

var headerRender = function headerRender(h, _ref) {
  var menus = _ref.menus,
      redirect = _ref.redirect;
  var domArr = [];
  if (!Array.isArray(menus)) return domArr;
  menus.forEach(function (item) {
    if (item.children && item.children.length) {
      domArr.push(h("el-submenu", {
        "attrs": {
          "index": item.id + ''
        },
        "key": item.name + item.id
      }, [h("template", {
        "slot": "title"
      }, [item.meta.icon ? h("svg-icon", {
        "attrs": {
          "iconName": item.meta.icon
        }
      }) : null, item.meta.title, h("span", {
        "slot": "title",
        "class": "hide"
      }, [h("span", {
        "class": "txt"
      }, [item.meta.title])])]), headerRender(h, {
        menus: item.children,
        redirect: redirect
      })]));
    } else {
      var className = "item-children".concat(item.meta && item.meta.hidden ? ' hide' : '');
      domArr.push(h("el-menu-item", {
        "attrs": {
          "index": item.id
        },
        "key": item.name + item.id,
        "class": className,
        "on": {
          "click": function click() {
            return redirect(item);
          }
        }
      }, [item.meta.icon ? h("svg-icon", {
        "attrs": {
          "iconName": item.meta.icon
        }
      }) : null, h("span", {
        "slot": "title",
        "class": "hide"
      }, [h("span", {
        "class": "txt"
      }, [item.meta.title])]), item.meta.title]));
    }
  });
  return domArr;
};

var _default = MenuRender;
exports.default = _default;